import BaseService from './baseService';

/**
 * Service for One-Line diagram
 */
export default class OneLineService extends BaseService {
    constructor() {
        super('one-line');
    }

    /**
    * Gets list of scenarios for specified task
    * @param {number} taskId Task identifier
    * @returns list of scenarios
    */
    getScenarios = (taskId: number) => this.httpGetRequest(`${taskId}/scenarios`);

    /**
     * Get areas list
     * @param {number} scenarioId Scenario id
     * @returns list of areas
     */
    getAreas = (scenarioId: number) => this.httpGetRequest(`${scenarioId}/areas`);

    /**
     * Gets unit types list 
     * @param {number} scenarioId Scenario id 
     * @returns list of unit types
     */
    getUnitTypes = (scenarioId: number) => this.httpGetRequest(`${scenarioId}/unit-types`);

    /**
     * Gets node which stores one of injectors/hubs/nodes 
     * @param {number} scenarioId Scenario id
     * @param {Array<string>} areas Areas filter
     * @param {Array<string>} unitTypes Unit types filter
     * @param {string} type Enode type (injector, hub, node)
     * @returns list of filterd nodes
     */
    getNodesLookup = (scenarioId: number, areas: string[] = [], unitTypes: string[] = [], type: string, searchString: string) =>
        this.httpGetRequest(`${scenarioId}/enodes?${this.generateQueryString({ a: areas, u: unitTypes, type: type, s: searchString })}`);

    /**
     * Gets diagram for nodes with specified depth
     * @param {number} scenarioId Scenario id
     * @param {string} type Enode type (injector, hub, node)
     * @param {number} steps Depth from starting bus
     * @param {string} enode NAME of starting node 
     * @returns List of nodes and branches required to build this chart 
     */
    getDiagram = (scenarioId: number, type: string, steps: number, enode: string) =>
        this.httpGetRequest(`${scenarioId}/diagram?${this.generateQueryString({ steps, type, enode })}`);

    /**
     * Get the shortest path between 2 BUSES
     * @param {number} scenarioId Scenario id
     * @param {number} fromBus Starting point
     * @param {number} toBus Finish point
     * @returns List of nodes and branches required to build this chart
     */
    getShortestPath = (scenarioId: number, fromBus: string, toBus: string) =>
        this.httpGetRequest(`${scenarioId}/path?${this.generateQueryString({ fromBus, toBus })}`);

    /**
     * Clears cached queries for specified case
     * @param {number} scenarioId Scenario id
     * @returns void
     */
    clearCache = (scenarioId: number) => this.httpPostRequest(`${scenarioId}/clear`);
}
